
export const width = {
  name: 'width'
}

export const height = {
  name: 'height'
}

export const minWidth = {
  name: 'min-width'
}

export const minHeight = {
  name: 'min-height'
}

export const maxWidth = {
  name: 'max-width'
}

export const maxHeight = {
  name: 'max-height'
}